import get from 'lodash/get';
import { getDocumentFields, getFileUrl, getOptimizedContentfulImage } from 'utils/helper';

export const getFeaturedProjectProps = (data) => {
  const {
    title,
    description,
    text,
    images,
  } = getDocumentFields(
    data,
    [
      'title',
      'description',
      'images',
      'text',
    ],
  );
  const imageUrl = getOptimizedContentfulImage(
    getFileUrl(get(images, '[0]')),
    { fm: 'webp', width: 350, height: 250 },
  );

  return {
    projectTitle: title,
    imageUrl,
    projectLink: description,
    text,
  };
};
